import { Button, Box } from '@material-ui/core'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Image } from '../../types/image'
import { Proforma } from '../../types/walletProforma'
import useStyles from './styles/ReceiptOfPaymemt'

interface ReceiptOfPaymentProps {
  proforma: Proforma
}

const ReceiptOfPayment: React.FC<ReceiptOfPaymentProps> = ({ proforma }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <SectionTitle title="Receipt of Payment" marginBottom />
      <div className={classes.card}>
        <Box className={classes.contentBox}>
          {proforma.attachments.map((attachment: Image) => (
            <img src={attachment.url} id={attachment.id} />
          ))}
        </Box>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<CloudDownloadIcon />}
          className={classes.downloadButton}
          onClick={() => {
            for (const attachment of proforma.attachments) {
              const link = document.createElement('a')
              link.href = attachment.url
              link.download = attachment.name
              link.target = '_blank'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }
          }}>
          {getTranslate('Download Receipt')}
        </Button>
      </div>
    </div>
  )
}

export default ReceiptOfPayment
